import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import MediaQuery from 'react-responsive';
import { propStyles } from '../utils/propStyles';
import FiltersToggle from './Filters/Components/FiltersToggle';
import Search from './Search';
import WatchListButton from './WatchListButton';
import ExplorerDownload from './ExplorerDownload';
import SortSelector from './SortSelector';
import { DataStore, FilterStore, AccessibilityStore } from '../stores';
import ResizeDetector from './ResizeDetector';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';

const SearchHeader = styled<any, any>('header', 'searchHeader', 'header')`
    ${propStyles};
    top: 0;
`;

SearchHeader.defaultProps = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    padding: 'lg',
};

interface HeaderProps {
    theme?: Theme;
    dataStore?: DataStore;
    filterStore?: FilterStore;
    accessibilityStore?: AccessibilityStore;
}

interface ThemeValue {
    [property: string]: string | number | Theme;
}

interface Theme {
    [property: string]: ThemeValue;
}

@inject('dataStore', 'filterStore', 'accessibilityStore')
@observer
class Header extends Component<HeaderProps> {
    render() {
        const {
            theme,
            dataStore,
            filterStore,
            accessibilityStore,
        } = this.props;

        return (
            <SearchHeader
                {...theme.SearchHeader}
                role="search"
                aria-label={accessibilityStore.searchLandmark}
            >
                <MediaQuery
                    query={
                        dataStore.config.filtersTop
                            ? `(max-width: ${theme.breakpoints.sm})`
                            : `(max-width: ${theme.breakpoints.md})`
                    }
                >
                    {matches =>
                        matches &&
                        !isNullOrEmpty(filterStore.filters) && (
                            <FiltersToggle
                                onClick={filterStore.toggleFilters}
                                filtersActive={filterStore.filtersActive}
                                filtersCount={filterStore.filtersCount}
                                expanded={filterStore.isFiltersOpen}
                            />
                        )
                    }
                </MediaQuery>
                {dataStore.config.identifierSearch &&
                    !dataStore.config.identifierSearch.hide &&
                    dataStore.config.identifierSearch.properties && (
                        <MediaQuery minWidth={theme.breakpoints.sm}>
                            {/* Tablet & Up Search Placement for Accessibility Tab Order */}
                            <Search
                                total={dataStore.total}
                                search={dataStore.searchValues}
                                onChange={dataStore.search}
                                clearSearch={dataStore.clearSearch}
                            />
                        </MediaQuery>
                    )}
                {dataStore.watchListEnabled && (
                    <WatchListButton
                        onClick={dataStore.toggleWatchList}
                        active={dataStore.watchListActive}
                        count={dataStore.watchListCount}
                    />
                )}
                <ResizeDetector handleWidth={true} handleHeight={true}>
                    <ExplorerDownload />
                </ResizeDetector>

                {dataStore.columnStore.sortableColumns.length > 0 && (
                    <MediaQuery maxWidth={theme.breakpoints.sm}>
                        <SortSelector order="2" />
                    </MediaQuery>
                )}

                {dataStore.config.identifierSearch &&
                    !dataStore.config.identifierSearch.hide &&
                    dataStore.config.identifierSearch.properties && (
                        <MediaQuery maxWidth={theme.breakpoints.sm}>
                            {/* Mobile Search Placement for Accessibility Tab Order */}
                            <Search
                                total={dataStore.total}
                                search={dataStore.searchValues}
                                onChange={dataStore.search}
                                clearSearch={dataStore.clearSearch}
                            />
                        </MediaQuery>
                    )}
            </SearchHeader>
        );
    }
}

export default withTheme(Header);



// WEBPACK FOOTER //
// ./src/Components/Header.tsx